<script setup lang="ts">
import type { MenuInst, MenuOption } from 'naive-ui'
import { useAppStore, useRouteStore, useTrackerStore } from '@/store'

const trackerStore = useTrackerStore()

const route = useRoute()
const appStore = useAppStore()
const routeStore = useRouteStore()

// 检测窗口宽度
function checkWindowWidth() {
  appStore.isMobile = window.innerWidth < 1200
  if (appStore.isMobile) {
    appStore.collapsed = true // 小屏幕强制折叠
  }
}

onMounted(() => {
  checkWindowWidth()
  window.addEventListener('resize', checkWindowWidth)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkWindowWidth)
})
const menuInstRef = ref<MenuInst | null>(null)

const expandedKeys = ref<string[]>([])

// 🔁 记录上一次点击的菜单 key, 防止重复点击
const lastSelectedKey = ref(route.path)
trackerStore.lastSelectedKey = lastSelectedKey.value

function selectMenuFn(key: string, item: MenuOption) {
  if (trackerStore.lastSelectedKey !== key) {
    trackerStore.reportBySpecialDirectives('Page_Jumpto', '侧边栏菜单')
  }
  trackerStore.lastSelectedKey = key
  // 用于处理菜单选择
  if (item.pid === null) {
    routeStore.expandedKeys = []
  }
}
function expandedKeysFn(keys: string[]) {
  routeStore.expandedKeys = keys
}

watch(
  () => route.path,
  () => {
    checkWindowWidth()
    menuInstRef.value?.showOption(routeStore.activeMenu as string)
  },
  { immediate: true },
)
</script>

<template>
  <!--
  <n-menu
    ref="menuInstRef"
    :collapsed="appStore.collapsed"
    :indent="20"
    :collapsed-width="64"
    :options="routeStore.menus"
    :value="routeStore.activeMenu"
    accordion
  />
  -->
  <n-menu
    ref="menuInstRef"
    class="menu"
    :class="[{ collapsedMenu: appStore.collapsed }]"
    :expanded-keys="routeStore.expandedKeys"
    :collapsed="appStore.collapsed"
    :indent="20"
    :collapsed-width="64"
    :options="routeStore.menus"
    :value="routeStore.activeMenu"
    accordion
    @update-value="selectMenuFn"
    @update:expanded-keys="expandedKeysFn"
  />
</template>
